<template>
	<div class="container-fluid">
	    <div class="m-2">
	    	<div class="row d-flex justify-content-center">
	    		<div class="col-12">
	    			<div class="row">
	    				<div class="col-12">
	    					<div class="alert alert-primary">
	    						<div class="h4 text-center">
	    							<linkto :link="'/types'"/>
	    							Típus módosítás
	    						</div>
	    					</div>
	    				</div>
	    			</div>
	    			<div class="row d-flex justify-content-center align-items-center">
	    				<typedata
	    					:change="true"
	    					:id="$route.params.id"
	    				>
	    				</typedata>
	    			</div>
	    		</div>
	    	</div>
	    </div>
	</div>
</template>

<script>
import typedata from './type_data'
export default {
  name: 'type',
  components: {
  	typedata
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/types/type.vue